// Configuration de l'application ESPRIT PISCINE

const appConfig = {
  // Affichage du sélecteur de langue dans le menu
  showLanguageSelector: false,

  // Langue par défaut
  defaultLanguage: 'fr',
};

export default appConfig;
